<template>
  <div class="page-wrap">
    <div class="footer-wrap" id="whistle">
      <div class="footer-card">
        <div class="footer-email">
        <div>
          <div class="footer-email-title">Pengaduan <span class="footer-email-title-span">Whistle Blowing</span></div>
          <div class="footer-email-text-one">Bantusaku berkomitmen terhadap sistem manajemen anti penyuapan dengan mengidentifikasi, mencegah, dan menangani tindakan penyuapan.</div>
          <div class="footer-email-text-two">Kamu dapat melaporkan tindakan yang bertentangan dengan hukum, etika, dan prosedur yang dilakukan oleh pihak internal BantuSaku.</div>
          <div class="footer-email-text-three">
            <div class="footer-email-text-three-text">
              <img class="footer-email-text-three-img" src="../assets/v3/team/email.png" alt="email">
              <span class="footer-email-text-three-text-text">Email : whistleblowing@bantusaku.id</span>
            </div>
          </div>
          </div>
          <div class="footer-email-text-three-img-two">
            <img  src="../assets/v3/team/about-dx.png" alt="email">
          </div>
        </div>
        <div class="footer-text">
          <div class="footer-text-one">
           <div class="footer-text-one-title">
            <img src="../assets/v3/team/about-xx.png" alt="">
            <div class="footer-text-one-title-text">Informasi <span style="color: #145246;">yang diperlukan</span> </div>
           </div>
           <div class="footer-text-one-text">
            <div class="footer-text-one-text-circle"></div>
            <div class="footer-text-one-text-ts">Deskripsi rinci dugaan pelanggaran (waktu, tempat, siapa yang terlibat penyuapan, dan kronologi)</div>
           </div>
            <div class="footer-text-one-text" style="margin-top: 0px;">
               <div class="footer-text-one-text-circle"></div>
            <div class="footer-text-one-text-ts">Bukti pendukung (jika ada)</div>
            </div>
             <div class="footer-text-one-text" style="margin-top: 0px;">
               <div class="footer-text-one-text-circle"></div>
            <div class="footer-text-one-text-ts">Nomor telepon / email aktif</div>
             </div>
          </div>
           <div class="footer-text-two">
            <div class="footer-text-two-title">
                <img src="../assets/v3/team/about-suo.png" alt="">
                 <div class="footer-text-two-title-text">Bantusaku <span style="color: #145246;">menjamin kerahasiaan identitas pelapor</span> </div>
            </div>
            <div class="footer-text-two-text">
            <div class="footer-text-two-text-circle"></div>
            <div class="footer-text-two-text-ts">Identitas pelapor bersifat opsional. Kamu diperbolehkan menyampaikan informasi tanpa identitas (anonim).</div>
           </div>
           </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Whistleblowing'
}
</script>

<style lang="scss" scoped>
.page-wrap {
  width: 100%;
}
  .footer-wrap {
    width: 100%;
    background: white;
    .footer-card {
      width: 1399px;
      height: 1150px;
      margin: 0 auto;

      .footer-email {
        height: 520px;
        margin-top: 57px;
        display: flex;
      
        .footer-email-title {
          font-size: 38px;
          color: #1D1D1D;
          font-weight: 600;
          margin-top: 32px;
          margin-left: 42px;
        }
        .footer-email-title-span {
          color: #145246;
        }
        .footer-email-text-one{
          width: 982px;
          height: 132px;
          margin-left: 42px;
          margin-top: 20px;
          font-size: 28px;
          line-height: 42px;
          display: flex;
        }
        .footer-email-text-two{
          width: 982px;
          height: 132px;
          margin-left: 42px;
          margin-top: 14px;
          font-size: 28px;
          line-height: 42px;
        }
        .footer-email-text-three{
          width: 760px;
          height: 72px;
          background-color: #ACDDB1;
          margin-left: 42px;
          margin-top: 20px;
          border-radius: 36px;
          border: 1px solid #28543F;
          margin-bottom: 32px;
          .footer-email-text-three-text{
            width: 690px;
            height: 46px;
            margin-top: 11px;
            margin-left: 35px;
            margin-right: 35px;
            margin-bottom: 15px;
            .footer-email-text-three-img{
              margin-bottom: 15px;
            }
            .footer-email-text-three-text-text{
              font-size: 34px;
              color: #28543F;
              text-align: left;
              margin-left: 12px;
              margin-bottom: 15px;
            }
          }
        }
        .footer-email-text-three-img-two{
          width: 320px;
          height: 320px;
        }
        .footer-email-text-three-img-two img{
          margin-top: 100px ;
          margin-right: 42px;
          margin-bottom: 100px;
        }
      }

      .footer-text {
        height: 505px;
        .footer-text-one {
         width: 1170px;
         height: 268px;
         margin-left: 32px;
         margin-top: 40px;
         .footer-text-one-title{
          width: 585px;
          height: 53px;
          display: flex;
          align-items: center;
          .footer-text-one-title-text{
          margin-left: 13px;
          font-size: 38px;
          color: #1D1D1D;
          font-weight: 600;
         }
         }
         .footer-text-one-text{
          width: 1148px;
          height: 84px;
          font-size: 28px;
          color: #1D1D1D;
          text-align: left;
          display: flex;
          align-items: center;
          margin-left: 22px;
          margin-top: 20px;
          .footer-text-one-text-circle{
           width: 12px;
           height: 12px;
           background: #145246;
           border-radius: 50%;
           flex-shrink: 0;
          }
          .footer-text-one-text-ts{
            margin-left: 28px;
          }
         }
        }
        .footer-text-two{
          width: 1148px;
          height: 157px;
          margin-top: 80px;
          margin-bottom: 70px;
          margin-left: 32px;
          .footer-text-two-title{
          width: 1148px;
          height: 53px;
          display: flex;
          align-items: center;
          .footer-text-two-title-text{
          margin-left: 13px;
          font-size: 38px;
          color: #1D1D1D;
          font-weight: 600;
         }
         }
           .footer-text-two-text{
          width: 1148px;
          height: 84px;
          font-size: 28px;
          color: #1D1D1D;
          text-align: left;
          display: flex;
          align-items: center;
          margin-left: 22px;
          margin-top: 20px;
          .footer-text-two-text-circle{
           width: 12px;
           height: 12px;
           background: #145246;
           border-radius: 50%;
           flex-shrink: 0;
          }
          .footer-text-two-text-ts{
            margin-left: 28px;
          }
         }
        }
      }
    }
  }


  /* Responsive fixes */
  @media (max-width: 1400px) {
    .footer-wrap .footer-card {
      width: 100%;
      height: auto;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .footer-wrap .footer-card .footer-email {
      width: 100%;
      height: auto;
      padding-bottom: 20px;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-one,
    .footer-wrap .footer-card .footer-email .footer-email-text-two {
      width: 100%;
      height: auto;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-three {
      width: auto;
      padding-right: 20px;
    }
    .footer-wrap .footer-card .footer-text {
      width: 100%;
      height: auto;
    }
    .footer-wrap .footer-card .footer-text .footer-text-one,
    .footer-wrap .footer-card .footer-text .footer-text-two {
      width: 100%;
      height: auto;
    }
    .footer-wrap .footer-card .footer-text .footer-text-one .footer-text-one-text,
    .footer-wrap .footer-card .footer-text .footer-text-two .footer-text-two-text {
      width: 100%;
      height: auto;
    }
    .footer-wrap .footer-card .footer-text .footer-text-one .footer-text-one-title,
    .footer-wrap .footer-card .footer-text .footer-text-two .footer-text-two-title {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .footer-wrap .footer-card .footer-email {
      flex-direction: column;
      margin-top: 20px;
      display: flex;
    }
    .footer-wrap .footer-card .footer-email > div:first-child {
      display: contents;
    }
    .footer-wrap .footer-card .footer-email .footer-email-title {
      order: 1;
      margin-left: 10px;
      font-size: 28px;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-one {
      order: 2;
      margin-left: 10px;
      font-size: 16px;
      line-height: 24px;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-two {
      order: 3;
      margin-left: 10px;
      font-size: 16px;
      line-height: 24px;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-three-img-two {
      order: 4;
      width: 100%;
      text-align: center;
      height: auto;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-three-img-two img {
      margin: 20px 0;
      width: 60%;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-three {
      order: 5;
      margin: 10px auto 30px auto;
      width: 90%;
      max-width: 380px;
      height: 50px;
      border-radius: 25px;
      padding: 0 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #28543F;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-three .footer-email-text-three-text {
      margin: 0;
      width: auto;
      height: auto;
      flex-direction: row;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-three .footer-email-text-three-text .footer-email-text-three-img {
      width: 24px;
      margin: 0 10px 0 0;
    }
    .footer-wrap .footer-card .footer-email .footer-email-text-three .footer-email-text-three-text .footer-email-text-three-text-text {
      font-size: 14px;
      margin: 0;
    }
    
    .footer-wrap .footer-card .footer-text .footer-text-one,
    .footer-wrap .footer-card .footer-text .footer-text-two {
      margin-left: 10px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .footer-wrap .footer-card .footer-text .footer-text-one .footer-text-one-title .footer-text-one-title-text,
    .footer-wrap .footer-card .footer-text .footer-text-two .footer-text-two-title .footer-text-two-title-text {
      font-size: 22px;
    }
    .footer-wrap .footer-card .footer-text .footer-text-one .footer-text-one-text,
    .footer-wrap .footer-card .footer-text .footer-text-two .footer-text-two-text {
      font-size: 16px;
      margin-left: 0;
      align-items: flex-start;
      margin-top: 10px;
    }
    .footer-wrap .footer-card .footer-text .footer-text-one .footer-text-one-text .footer-text-one-text-circle,
    .footer-wrap .footer-card .footer-text .footer-text-two .footer-text-two-text .footer-text-two-text-circle {
      margin-top: 6px;
    }
    .footer-wrap .footer-card .footer-text .footer-text-one .footer-text-one-text .footer-text-one-text-ts,
    .footer-wrap .footer-card .footer-text .footer-text-two .footer-text-two-text .footer-text-two-text-ts {
      margin-left: 10px;
      width: calc(100% - 22px);
    }
  }
</style>
